import axios from "axios";

const CDN_URL = process.env.REACT_APP_CDN_URL;
const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const config = {
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
};
const CURRENT_PROFILE_KEY = "currentCompanyProfile";
const CURRENT_MEMBERSHIP = "currentMembership";

const companyAvatarEnergyLarge = `${CDN_URL}common/company-avatar-energy-lg.svg`;
const companyAvatarEnergyDropDownLarge = `${CDN_URL}common/company-avatar-energy-dropdown-lg.svg`;

export class CompanyProfileApi {
  constructor() {
    this.baseUrl = process.env.REACT_APP_API_BASE_URL;
    this.config = {
      withCredentials: true,
      headers: { "Content-Type": "application/json" },
    };
  }

  get() {
    const url = `${this.baseUrl}/billing/profile`;

    return axios.get(url, this.config);
  }

  checkForAlerts = () => {
    const url = `${this.baseUrl}/user/alerts`;

    return axios.get(url, this.config);
  };

  getCompanyAvatar = (position, type) => {
    if (type === "energy") {
      return companyAvatarEnergyDropDownLarge;
    }
    return companyAvatarEnergyLarge;
  };

  startDownload = (downloadURL) => {
    const url = `${BASE_URL}${downloadURL}`;
    return axios.get(url, config);
  };
  sendSOC = (id) => {
    const url = `${BASE_URL}/organization/${id}/soc`;
    return axios.get(url, config);
  };
  checkValidNDA = (id) => {
    const url = `${BASE_URL}/organization/nda/${id}`;
    return axios.get(url, config);
  };

  isBetaOrg = (organizationId, memberships) => {
    if (!organizationId) {
      return false;
    }
    const currentMembershipSelected = memberships.filter(
      (membership) =>
        Number(membership.organizationId) === Number(organizationId)
    );
    if (currentMembershipSelected[0].beta) {
      return true;
    } else {
      return false;
    }
  };
}

export const saveCompanyProfile = (profile) => {
  try {
    sessionStorage.setItem(CURRENT_PROFILE_KEY, JSON.stringify(profile));
  } catch (e) {
    console.log(e);
    return false;
  }

  return true;
};

export const getCurrentCompanyProfile = () => {
  let currentMembership;
  try {
    currentMembership = JSON.parse(sessionStorage.getItem(CURRENT_PROFILE_KEY));
  } catch (e) {
    console.log(e);
    return null;
  }

  return currentMembership;
};

export const getCurrentMembership = () => {
  let currentMembership;
  try {
    currentMembership = JSON.parse(sessionStorage.getItem(CURRENT_MEMBERSHIP));
  } catch (e) {
    console.log(e);
    return null;
  }

  return currentMembership;
};
